import moment from 'moment';
import toast from '~~elements/Toast';
import CTMultilingual from './Multilingual';

export const validFormData = (formData, toastRequired) => {
  const title = formData.title.trim();
  const startAt = new Date(formData.start_at);
  const endAt = new Date(formData.end_at);
  if (title === '') {
    if (toastRequired) {
      toast(CTMultilingual(`TOURNAMENT.ERROR.TITLE`), { status: 'error', second: 2 });
    }
    return false;
  }

  if (!moment(startAt).isValid() || !moment(endAt).isValid() || moment(startAt).isAfter(endAt)) {
    if (toastRequired) {
      toast(CTMultilingual(`TOURNAMENT.ERROR.DATES`), { status: 'error', second: 2 });
    }
    return false;
  }

  return true;
};

export const currencyDisplay = {
  NTD: {
    text: 'NT$',
    toFixed: 0,
  },
};

export const getPriceDisplay = (currency, retailPrice) => {
  if (!currencyDisplay[currency]) {
    throw new Error();
  }

  return `${currencyDisplay[currency].text} ${retailPrice.toFixed(currencyDisplay[currency].toFixed)}`;
};

export const getTotalPrice = (pluginsPrice, pluginsDecision) => {
  let total = 0.0;

  if (!currencyDisplay[pluginsPrice.currency]) {
    throw new Error();
  }

  Object.keys(pluginsDecision).forEach((pluginName) => {
    if (!pluginsPrice[pluginName]) {
      throw new Error();
    }

    if (pluginsDecision[pluginName] === false) {
      return;
    }

    total += pluginsPrice[pluginName].retail_price;
  });

  return total;
};

export const getTotalPriceDisplay = (pluginsPrice, pluginsDecision) => {
  const total = getTotalPrice(pluginsPrice, pluginsDecision);

  if (!currencyDisplay[pluginsPrice.currency]) {
    throw new Error();
  }

  return getPriceDisplay(pluginsPrice.currency, total);
};

export const validContact = (contact, toastRequired) => {
  const name = contact.name.trim();
  const phone = contact.phone.trim();
  const lineID = contact.lineID.trim();

  if (name === '') {
    if (toastRequired) {
      toast(CTMultilingual(`CONTACT.ERROR`), { status: 'error', second: 2 });
    }
    return false;
  }

  if (phone === '' && lineID === '') {
    if (toastRequired) {
      toast(CTMultilingual(`CONTACT.ERROR`), { status: 'error', second: 2 });
    }
    return false;
  }

  return true;
};
